<div class="reminder-modal-container">
  <!-- Header -->
  <div class="reminder-modal-header">
    <div class="reminder-modal-header-left">
      <div class="reminder-modal-icon-container">
        <mat-icon class="text-white">{{ isEditMode ? 'edit' : 'add' }}</mat-icon>
      </div>
      <h3 class="reminder-modal-title">{{ getModalTitle() }}</h3>
    </div>
    <button class="reminder-modal-close-btn" (click)="onCancel()" aria-label="Close modal">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="reminder-modal-content">
    <form [formGroup]="reminderForm" (ngSubmit)="onSubmit()">
      <!-- Title -->
      <div class="reminder-form-field">
        <label class="reminder-form-label">
          Title <span class="required">*</span>
        </label>
        <input type="text" formControlName="title" placeholder="Enter reminder title" class="reminder-form-input">
      </div>

      <!-- Type -->
      <div class="reminder-form-field">
        <label class="reminder-form-label">
          Type <span class="required">*</span>
        </label>
        <div class="reminder-type-selector">
          @for (type of reminderTypes; track type) {
            <button type="button" class="reminder-type-btn"
              [class.active]="selectedType === type.value" (click)="selectType(type.value)">
              <mat-icon>{{ type.icon }}</mat-icon>
              <span class="type-label">{{ type.label }}</span>
            </button>
          }
        </div>
      </div>

      <!-- Date & Time -->
      <div class="reminder-form-row">
        <div class="reminder-form-field">
          <label class="reminder-form-label">
            Date <span class="required">*</span>
          </label>
          <input type="date" formControlName="date" class="reminder-form-input">
        </div>
        <div class="reminder-form-field">
          <label class="reminder-form-label">
            Time <span class="required">*</span>
          </label>
          <input type="time" formControlName="time" class="reminder-form-input">
        </div>
      </div>

      <!-- Priority -->
      <div class="reminder-form-field">
        <label class="reminder-form-label">Priority</label>
        <div class="reminder-priority-selector">
          @for (priority of priorities; track priority) {
            <button type="button" class="reminder-priority-btn"
              [class.active]="selectedPriority === priority.value"
              [class.low]="priority.value === 'low' && selectedPriority === priority.value"
              [class.medium]="priority.value === 'medium' && selectedPriority === priority.value"
              [class.high]="priority.value === 'high' && selectedPriority === priority.value"
              (click)="selectPriority(priority.value)">
              {{ priority.label }}
            </button>
          }
        </div>
      </div>

      <!-- Remind me before -->
      <div class="reminder-form-field">
        <label class="reminder-form-label">Remind me before</label>
        <select formControlName="alert_before" class="reminder-form-input">
          @for (option of leadTimeOptions; track option) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>

      <!-- Location -->
      <div class="reminder-form-field">
        <label class="reminder-form-label">Location (optional)</label>
        @if (selectedLocationsFromDropdown.length > 0) {
          <div class="pt-1 pb-2">
            <mat-chip-listbox class="chip-list" aria-label="Selected Locations">
              @for (location of selectedLocationsFromDropdown; track location) {
                <mat-chip-option [removable]="true"
                  (removed)="removeLocation(location)">
                  {{ location.address }}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-option>
              }
            </mat-chip-listbox>
          </div>
        }
        <div class="reminder-input-with-icon">
          <mat-icon class="input-icon">location_on</mat-icon>
          <input type="text" formControlName="location" placeholder="Search for a location"
            class="reminder-form-input with-icon" (keydown.enter)="getLocationEnter($event)"
            [matMenuTriggerFor]="locationMenu" #locationMenuTrigger="matMenuTrigger">
        </div>
      </div>

      <!-- Description -->
      <div class="reminder-form-field">
        <label class="reminder-form-label">Description (optional)</label>
        <textarea formControlName="description" placeholder="Add any additional notes" rows="3"
          class="reminder-form-textarea">
        </textarea>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <div class="reminder-modal-footer">

    <div class="footer-buttons">
      <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="isSubmitting">
        Cancel
      </button>
      <button type="button" class="btn-submit" [disabled]="!isFormValid() || isSubmitting" (click)="onSubmit()">
        <mat-icon>{{ isSubmitting ? 'hourglass_empty' : (isEditMode ? 'edit' : 'add') }}</mat-icon>
        {{ isSubmitting ? (isEditMode ? 'Updating...' : 'Adding...') : getSubmitButtonText() }}
      </button>
    </div>
  </div>
</div>

<!-- Mat menu for location -->
<mat-menu #locationMenu="matMenu" class="location-menu">
  <div class="location-list-container">
    <div class="location-list-header">
      Use this location :
      <span (click)="onLocationSpanClick()" class="location-span-name">
      {{ reminderForm.get("location")?.value }}</span>
    </div>
    @for (item of locationList; track item) {
      <div class="location-item d-flex align-items-center py-2 px-3"
        (click)="onLocationSelected(item)">
        <div class="location-name">{{ item.address }}</div>
      </div>
    }
  </div>
</mat-menu>